<!-- Fancy in-app alert banner for immediate bookings (global overlay). -->
<div class="ab-stack" *ngIf="banners.length">
  <div *ngFor="let a of banners" class="ab-card" [class.ab-many]="(a.count ?? 1) > 1" (click)="openBanner(a)">
    <span class="ab-pulse"></span>
    <span class="ab-icon">🚑<span *ngIf="(a.count ?? 1) > 1" class="ab-count">{{ a.count }}</span></span>
    <div class="ab-body">
      <div class="ab-title">{{ a.titleKey | translate:{ count: a.count } }}</div>
      <div class="ab-detail" *ngIf="(a.count ?? 1) <= 1">{{ a.detail }} · <span class="ab-num">{{ a.tripNumber }}</span></div>
      <div class="ab-detail" *ngIf="(a.count ?? 1) > 1">{{ 'notif.tap_to_review' | translate }}</div>
    </div>
    <button type="button" class="ab-open" (click)="openBanner(a); $event.stopPropagation()">{{ ((a.count ?? 1) > 1 ? 'notif.action_view_all' : 'notif.action_view') | translate }}</button>
    <button type="button" class="ab-x" (click)="dismissBanner(a.id); $event.stopPropagation()" aria-label="Dismiss">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>
    </button>
  </div>
</div>

<ng-container *ngIf="showChrome; else authOutlet">
  <div class="mm shell" [class.dark]="darkMode" [class.light]="!darkMode" [class.sb-open]="sbOpen">

    <!-- Mobile: dimmed backdrop behind the off-canvas sidebar -->
    <div class="sb-backdrop" *ngIf="sbOpen" (click)="sbOpen = false"></div>

    <!-- ── Sidebar ───────────────────────────────────────── -->
    <aside class="sb">
      <div class="sb-head">
        <img src="https://web04.ireport-app.com/organization/Mobimed/images/logo.png"
             alt="Mobimed"
             class="sb-logo"
             (error)="onLogoError($event)">
      </div>

      <div class="sb-body">

        <!-- INBOX group (WP1455) — the bookings still waiting for their
             confirmation mail to go out, on top because it is the queue the
             dispatcher works down first. No view of its own: it is the Bookings
             list with the "Zur Bestätigung" filter preselected. -->
        <ng-container *ngIf="canSee('bookings')">
          <div class="sb-group">{{ 'nav.sec.inbox' | translate }}</div>

          <a class="nav" [class.on]="onToConfirm" routerLink="/trips" [queryParams]="{ status: 'zur_best' }">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
            <span style="flex:1">{{ 'bs.pending_conf' | translate }}</span>
            <span class="count alert" *ngIf="toConfirmCount > 0">{{ toConfirmCount }}</span>
          </a>
        </ng-container>

        <!-- OPERATIONS group -->
        <ng-container *ngIf="canSee('dispatch') || canSee('bookings')">
          <div class="sb-group">{{ 'nav.sec.ops' | translate }}</div>

          <a *ngIf="canSee('dispatch')" class="nav" [class.on]="isRoute('/dashboard')" routerLink="/dashboard">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h4l3-8 5 16 3-8h5"/></svg>
            <span style="flex:1">{{ 'nav.dispatch' | translate }}</span>
            <span class="count" *ngIf="dispatchCount > 0">{{ dispatchCount }}</span>
          </a>

          <a *ngIf="canSee('bookings')" class="nav" [class.on]="isRoute('/trips') && !onToConfirm" routerLink="/trips">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M4 9h16M8 3v4M16 3v4"/></svg>
            <span style="flex:1">{{ 'nav.bookings' | translate }}</span>
            <span class="count" *ngIf="bookingCount > 0">{{ bookingCount }}</span>
          </a>
        </ng-container>

        <!-- Messages (WP 1211) — available to every signed-in staff member -->
        <a class="nav" [class.on]="isRoute('/chat')" routerLink="/chat">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z"/></svg>
          <span style="flex:1">{{ 'nav.messages' | translate }}</span>
          <span class="count" *ngIf="chatUnread > 0">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
        </a>

        <!-- FLEET group -->
        <ng-container *ngIf="canSee('fleet') || canSee('drivers')">
          <div class="sb-group">{{ 'nav.sec.fleet' | translate }}</div>

          <a *ngIf="canSee('fleet')" class="nav" [class.on]="isRoute('/vehicles')" routerLink="/vehicles">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>
            <span style="flex:1">{{ 'nav.fleet' | translate }}</span>
            <span class="count" *ngIf="vehicleCount > 0">{{ vehicleCount }}</span>
          </a>

          <a *ngIf="canSee('drivers')" class="nav" [class.on]="isRoute('/drivers')" routerLink="/drivers">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.4"/><path d="M3 20c0-3.3 2.7-5 6-5s6 1.7 6 5"/><path d="M16 5.2A3.4 3.4 0 0 1 16 12M21 20c0-2.8-1.6-4.4-4-4.8"/></svg>
            <span style="flex:1">{{ 'nav.drivers' | translate }}</span>
            <span class="count" *ngIf="driverCount > 0">{{ driverCount }}</span>
          </a>
        </ng-container>

        <!-- CUSTOMERS & FINANCE group -->
        <ng-container *ngIf="canSee('patients') || canSee('billing')">
          <div class="sb-group">{{ 'nav.sec.people' | translate }}</div>

          <a *ngIf="canSee('patients')" class="nav" [class.on]="isRoute('/customers')" routerLink="/customers">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>
            <span style="flex:1">{{ 'nav.patients' | translate }}</span>
            <span class="count" *ngIf="institutionCount > 0">{{ institutionCount }}</span>
          </a>

          <a *ngIf="canSee('billing')" class="nav" [class.on]="isRoute('/billing')" routerLink="/billing">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/></svg>
            <span style="flex:1">{{ 'nav.billing' | translate }}</span>
            <span class="count" *ngIf="billingCount > 0">{{ billingCount }}</span>
          </a>
        </ng-container>

        <!-- ADMIN group -->
        <ng-container *ngIf="canSee('users')">
          <div class="sb-group">{{ 'nav.sec.admin' | translate }}</div>

          <a *ngIf="canSee('users')" class="nav" [class.on]="isRoute('/users')" routerLink="/users">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.4"/><path d="M3 20c0-3.3 2.7-5 6-5s6 1.7 6 5"/><path d="M16 5.2A3.4 3.4 0 0 1 16 12M21 20c0-2.8-1.6-4.4-4-4.8"/></svg>
            <span style="flex:1">{{ 'nav.users' | translate }}</span>
          </a>

          <a *ngIf="canSee('users')" class="nav" [class.on]="isRoute('/roles')" routerLink="/roles">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3Z"/><path d="m9 12 2 2 4-4"/></svg>
            <span style="flex:1">{{ 'nav.roles' | translate }}</span>
          </a>

          <a *ngIf="canSee('settings')" class="nav" [class.on]="isRoute('/settings')" routerLink="/settings">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></svg>
            <span style="flex:1">{{ 'nav.settings' | translate }}</span>
          </a>

          <a *ngIf="canSee('settings')" class="nav" [class.on]="isRoute('/vehicle-types')" routerLink="/vehicle-types">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h10v9H3zM13 10h3.8l3.2 3v3H13zM3 11.5h10"/><circle cx="7" cy="18" r="1.7"/><circle cx="17" cy="18" r="1.7"/></svg>
            <span style="flex:1">{{ 'nav.vehicleTypes' | translate }}</span>
          </a>

          <a *ngIf="canSee('settings')" class="nav" [class.on]="isRoute('/requirements')" routerLink="/requirements">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="m8 8 1.5 1.5L12 7M8 14l1.5 1.5L12 13M15 8.5h2M15 14.5h2"/></svg>
            <span style="flex:1">{{ 'nav.requirements' | translate }}</span>
          </a>
        </ng-container>

        <ng-container *ngIf="canSee('dms')">
          <div class="sb-group">{{ 'nav.sec.documents' | translate }}</div>

          <a class="nav" [class.on]="isRoute('/dms')" routerLink="/dms">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h6"/></svg>
            <span style="flex:1">{{ 'nav.dms' | translate }}</span>
          </a>
        </ng-container>

      </div>

      <!-- Sidebar footer: user -->
      <div class="sb-foot">
        <!-- Mobile only: the topbar hides the language switcher ≤768px, so the
             drawer carries it instead (same DE/EN live, FR/IT pending set). -->
        <div class="sb-lang">
          <button [class.on]="currentLang === 'de'" (click)="langService.use('de')">DE</button>
          <button [class.on]="currentLang === 'en'" (click)="langService.use('en')">EN</button>
          <button disabled title="Français — bientôt">FR</button>
          <button disabled title="Italiano — presto">IT</button>
        </div>
        <div class="userbox" *ngIf="currentUser">
          <span class="avatar" [class.has-photo]="userPhoto"
                [style.background]="userPhoto ? 'transparent' : 'linear-gradient(150deg, var(--primary), var(--teal))'">
            <img *ngIf="userPhoto" [src]="userPhoto" [alt]="currentUser.firstName" />
            <ng-container *ngIf="!userPhoto">{{ userInitials }}</ng-container>
          </span>
          <div style="flex:1;min-width:0">
            <div class="u-name">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
            <div class="u-role">{{ currentUser.role | lowercase }}</div>
          </div>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
        </div>
      </div>
    </aside>

    <!-- ── Main column ─────────────────────────────────── -->
    <div class="main">
      <header class="topbar">
        <!-- Mobile: hamburger opens the off-canvas sidebar (hidden on desktop) -->
        <button type="button" class="btn btn-icon sb-burger" (click)="sbOpen = !sbOpen" aria-label="Menu">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
        </button>
        <div class="crumb">
          <a href="#">{{ currentSection }}</a>
          <span class="sep">/</span>
          <b>{{ pageTitle }}</b>
        </div>
        <div class="search" style="margin-left:8px">
          <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          <input [placeholder]="'shell.search' | translate" />
        </div>
        <div class="top-right">
          <div class="notif-wrap" style="position:relative">
            <button class="btn btn-icon" style="position:relative" (click)="toggleNotif()" [title]="'notif.title' | translate"
                    [style.color]="notifHasAlert ? 'var(--danger)' : null">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>
              <span class="notif-badge" *ngIf="notifUnread > 0" [class.alert]="notifHasAlert">{{ notifUnread > 9 ? '9+' : notifUnread }}</span>
            </button>
            <div class="notif-panel" *ngIf="notifOpen">
              <div class="notif-panel-head">
                <span>{{ 'notif.title' | translate }}</span>
                <button type="button" class="notif-clear" (click)="notifSvc.clear()" *ngIf="notifAlerts.length">{{ 'notif.clear' | translate }}</button>
              </div>
              <div class="notif-empty" *ngIf="!notifAlerts.length">{{ 'notif.empty' | translate }}</div>
              <button type="button" class="notif-item" *ngFor="let a of notifAlerts" (click)="goToNotif(a)">
                <span class="notif-dot-sev" [class.alert]="a.severity === 'alert'"></span>
                <span class="notif-item-body">
                  <span class="notif-item-title">{{ a.titleText || (a.titleKey | translate) }}</span>
                  <span class="notif-item-detail">{{ a.detail }}<ng-container *ngIf="a.tripNumber"> · {{ a.tripNumber }}</ng-container></span>
                </span>
              </button>
            </div>
          </div>
          <button class="btn btn-icon" (click)="toggleTheme()" [title]="darkMode ? 'Light mode' : 'Dark mode'">
            <svg *ngIf="!darkMode" viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.5A8 8 0 0 1 9.5 4 7 7 0 1 0 20 14.5Z"/></svg>
            <svg *ngIf="darkMode"  viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/></svg>
          </button>
          <div class="top-sep"></div>

          <!-- Language switcher: DE/EN active, FR/IT disabled -->
          <div class="seg-mini">
            <button [class.on]="currentLang === 'de'" (click)="langService.use('de')">DE</button>
            <button [class.on]="currentLang === 'en'" (click)="langService.use('en')">EN</button>
            <button disabled style="opacity:.4;cursor:not-allowed" title="Français — bientôt">FR</button>
            <button disabled style="opacity:.4;cursor:not-allowed" title="Italiano — presto">IT</button>
          </div>
          <div class="top-sep"></div>

          <!-- Logged-in user chip -->
          <div class="top-user" *ngIf="currentUser">
            <span class="top-avatar" [class.has-photo]="userPhoto"
                  [style.background]="userPhoto ? 'transparent' : null">
              <img *ngIf="userPhoto" [src]="userPhoto" [alt]="currentUser.firstName" />
              <ng-container *ngIf="!userPhoto">{{ userInitials }}</ng-container>
            </span>
            <div class="top-user-info">
              <span class="top-user-name">{{ currentUser.firstName }}</span>
              <span class="top-user-role">{{ currentUser.role | lowercase }}</span>
            </div>
          </div>
          <button class="btn btn-icon" (click)="logout()" title="Logout">
            <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </button>

          <div class="top-sep"></div>
          <button class="btn btn-primary btn-sm" style="height:38px" *ngIf="canManage('bookings')" routerLink="/trips/new">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
            <span class="bk-new-label">{{ 'bk.new' | translate }}</span>
          </button>
        </div>
      </header>

      <div class="canvas-scroll">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
</ng-container>

<ng-template #authOutlet>
  <router-outlet></router-outlet>
</ng-template>
